import { observer } from 'mobx-react-lite';
import { FC, MutableRefObject } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { OnboardingPopover } from '@gem/ui-kit';

import { OnboardingType } from 'APP/constants/onboarding';
import { useOnboardingManager } from 'APP/main/hooks/onboardingManager/useOnboardingManager';

interface ISpaceFriendsOnboardingProps {
  reference: MutableRefObject<HTMLElement | null>;
}

export const SpaceFriendsOnboarding: FC<ISpaceFriendsOnboardingProps> = observer(
  ({ reference }) => {
    const { t } = useTranslation();
    const presenter = useOnboardingManager(OnboardingType.SpaceFriends);

    if (!presenter.isNeedToShow) {
      return null;
    }

    return (
      <OnboardingPopover
        reference={reference}
        description={t('space_onboarding_friends')}
        handleClose={presenter.handleClose}
        isOpened={presenter.isOpened}
      />
    );
  }
);
